import { AdminList } from "../../../admin/fragments/emails/admin-email-list";
import { zget } from "../Fetch";
import { xget, xhttp } from "../Fetchv2";
import { PGST } from "../schemas/pg.schema-types.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Admin {
	async changeEmail(email: string, email2: string, password: string) {
		let response = await xhttp<{ ok: number }>(`/admin/users/email`, "PUT", { email, email2, password });
		return response;
	}
	async createUser(body: Pick<PGSchema.users, "id" | "name" | "last_name" | "email">, password: string, onlyFirebase = false) {
		let response = await xhttp<{ insertedCount: number; _id: string }>(`/admin/users`, "POST", { user: body, password, onlyFirebase });
		return response;
	}

	async deleteUser(uids: string[]) {
		let response = await xhttp<{ ok: number }>(`/admin/users`, "DELETE", { uids });
		return response;
	}

	async deletePage(uids: string[]) {
		let response = await xhttp<{ ok: number }>(`/admin/pages`, "DELETE", { uids });
		return response;
	}
	async isSuders() {
		let response = await xget<{ sudo: boolean }>(`/admin/check`);
		return response;
	}
	async blockIP(ip: string, block = true) {
		let response = await xhttp<{ ok: number }>(`/admin/ip`, "POST", { ip, block });
		return response;
	}

	async blockUser(users: string[], disabled: boolean) {
		let response = await xhttp<{ ok: number }>(`/admin/users/block`, "POST", { users, disabled });
		return response;
	}

	async getAllAdmins() {
		let response = await zget<AdminList>(`/admin/list/admins`);
		return response;
	}

	async getAdminsOfPage(pgid: string) {
		let response = await xget<{
			roles: Pick<PGSchema.users_pages, "uid" | "rol">[];
			users: Pick<PGSchema.users, "id" | "name" | "last_name" | "username" | "email" | "wa_phone" | "tel">[];
			admins: (Pick<PGSchema.users, "id" | "name" | "last_name" | "username" | "email" | "wa_phone" | "tel"> & { rol: number })[];
		}>(`/admin/pages/${pgid}/admins`);
		response.json.admins = response.json.roles.map(r => {
			let user = response.json.users.find(u => u.id == r.uid);
			return {
				...user!,
				rol: r.rol
			};
		});
		return response;
	}

	async addDeleteAdminsOfPage(
		pgid: string,
		verb: "POST" | "DELETE",
		body: {
			uid: string;
			rol?: PGST.users_pages.rol;
			permissions?: number[];
		}
	) {
		let response = await xhttp<{}>(`/admin/pages/${pgid}/admins`, verb, body);
		return response;
	}
}
